import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueDragDrop from 'vue-drag-drop';
import VTooltip from 'v-tooltip'
//import firebase from 'firebase';



Vue.use(VTooltip)
 
Vue.use(VueDragDrop);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
